import { pushFileDownload } from '@app/components/TagManager';

export const eventToLink = (nameFile: string) => {
	pushFileDownload(nameFile);
};
